/**
 * Standard Tailwind CSS breakpoints
 * These match the default Tailwind v4 breakpoint values
 */
export const breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
  "3xl": "1792px",
  "4xl": "2048px",
} as const;

export type Breakpoint = keyof typeof breakpoints;
